import { I18NextService } from 'angular-i18next';

export function getTableHeaders(i18: I18NextService, isProratedColumnShown = false) {
  const headers = [
    {
      name: i18.t('shared:licenses.licenseType'),
      gridColSize: '10fr',
      gridColMin: '100px'
    },
    {
      name: i18.t('shared:licenses.unitPrice'),
      gridColSize: '3fr',
      gridColMin: '80px',
      class: '-end',
      isGridColumn: false,
      overflow: true
    },
    {
      name: i18.t('shared:licenses.discount'),
      gridColSize: '5fr',
      gridColMin: '50px',
      isGridColumn: false,
      class: '-end',
      overflow: false
    },
    {
      name: i18.t('shared:licenses.unitTotalPrice'),
      gridColSize: '5fr',
      gridColMin: '50px',
      isGridColumn: false,
      class: '-end',
      overflow: true
    },
    {
      name: i18.t('shared:licenses.quantity'),
      gridColSize: '5fr',
      gridColMin: '50px',
      isGridColumn: false,
      class: '-start',
      overflow: true
    },
    {
      name: i18.t('shared:licenses.lineItemPrice'),
      gridColSize: '5fr',
      gridColMin: '50px',
      isGridColumn: false,
      class: '-end',
      overflow: true
    }
  ];

  if (isProratedColumnShown) {
    const columnNumber = 2;
    headers.splice(columnNumber, 0, {
      name: i18.t('shared:licenses.unitProratedPrice'),
      gridColSize: '5fr',
      gridColMin: '160px',
      isGridColumn: false,
      class: '-end',
      overflow: true
    });
  }

  return headers;
}
